import validate from "/vercel/path1/node_modules/.pnpm/nuxt@3.19.3_@parcel+watcher@2.5.1_@types+node@14.18.33_@vue+compiler-sfc@3.5.22_db0@0.3.4_ior_ydkou6zpxanmnc6dgeqk2ysra4/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path1/node_modules/.pnpm/nuxt@3.19.3_@parcel+watcher@2.5.1_@types+node@14.18.33_@vue+compiler-sfc@3.5.22_db0@0.3.4_ior_ydkou6zpxanmnc6dgeqk2ysra4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}